import React from "react";
import { Navigate } from "react-router-dom";
import ChatAgent from "pages/chat-agent";
import { Domain, useDomain } from "utils/stage-utils";
import { useTaxType } from "hooks";
import { TaxType } from "common/constants";

const ChatAgentGuard: React.FC = () => {
  const domain = useDomain();
  const taxType = useTaxType();
  if (domain === Domain.PROD && taxType !== TaxType.USETAX) {
    return <Navigate to="/" replace />;
  }
  return <ChatAgent />;
};

export default ChatAgentGuard;
